import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { bootstrapSession } from './auth/sessionStore';
import { captureInvitePrefill } from './auth/invitePrefill';
import { ToastProvider } from './components/Toast';
import { DataSourceProvider } from './data/hooks';
import { DataError } from '@fsv/data';
import { applyHighContrast, readHighContrast } from './lib/contrastMode';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 400/403/404/409 will not change by asking again; offline (0) and 503 might.
      retry: (count, error) => count < 1 && !(error instanceof DataError && error.status !== 0 && error.status !== 503),
      staleTime: 30_000,
    },
  },
});

if (readHighContrast()) applyHighContrast(true);
// Before the router redirects to /login and drops the hash.
captureInvitePrefill();
void bootstrapSession();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <DataSourceProvider>
            <App />
          </DataSourceProvider>
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
